import { Stack, useLocalSearchParams } from 'expo-router';
import React from 'react';

import { ExperimentsPage } from '../../../../../llm-service/datasets/ExperimentsPage';

const readAgentId = (agentId: string | string[] | undefined): string => {
    if (typeof agentId === 'string') {
        return agentId;
    }
    return agentId?.[0] ?? '';
};

export default function ExperimentsRoute() {
    const { agentId } = useLocalSearchParams<{ agentId: string }>();

    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Experiments',
                }}
            />
            <ExperimentsPage agentId={readAgentId(agentId)} />
        </>
    );
}
